/**
 * Marquee Module
 * Creates infinite scrolling marquee effects
 */

export default function initMarquee() {
  const marqueeElements = document.querySelectorAll("[data-marquee]");

  if (marqueeElements.length === 0) return;

  marqueeElements.forEach((marquee) => {
    createMarquee(marquee);
  });
}

function createMarquee(element) {
  // Get configuration from data attributes
  const speed = parseFloat(element.dataset.marqueeSpeed) || 1; // Speed multiplier (1 = normal)
  const direction = element.dataset.marqueeDirection || "left"; // 'left' or 'right'
  const pauseOnHover = element.dataset.marqueePause !== "false"; // Pause on hover (default: true)

  const container = element.querySelector(".marquee-content");
  if (!container) {
    console.warn("Marquee container (.marquee-content) not found");
    return;
  }

  // Clone content for seamless loop
  const content = container.innerHTML;
  container.innerHTML = content + content;

  let animationId;
  let position = 0;
  let isPaused = false;

  // Calculate the width of one set of content
  const contentWidth = container.scrollWidth / 2;

  function animate() {
    if (!isPaused) {
      // Move based on direction
      if (direction === "left") {
        position -= speed * 0.5; // Adjust speed
        if (Math.abs(position) >= contentWidth) {
          position = 0; // Reset position for seamless loop
        }
      } else {
        position += speed * 0.5;
        if (position >= 0) {
          position = -contentWidth;
        }
      }

      container.style.transform = `translateX(${position}px)`;
    }

    animationId = requestAnimationFrame(animate);
  }

  // Start animation
  animate();

  // Pause on hover
  if (pauseOnHover) {
    element.addEventListener("mouseenter", () => {
      isPaused = true;
    });

    element.addEventListener("mouseleave", () => {
      isPaused = false;
    });
  }

  // Cleanup on window unload (optional)
  window.addEventListener("beforeunload", () => {
    cancelAnimationFrame(animationId);
  });
}
